module["exports"] = [
  "van",
  "van de",
  "van den",
  "van 't",
  "van het",
  "de",
  "den"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nl/name/tussenvoegsel.js
// module id = 1922
// module chunks = 0